/**
 * Red de aeropuertos de Tocumen S.A. La lista la comparten el listado y el nav
 * de la sección, así que vive aquí y no dentro de la página.
 *
 * `id` es la clave del namespace `aeropuertosPage.airports` de i18n.
 */
export type AirportKey = "tocumen" | "mppa" | "david" | "riohato";

export type AirportConfig = {
  id: AirportKey;
  code: string;
  image: string;
  href: string;
  isMain?: boolean;
};

export const AIRPORTS: AirportConfig[] = [
  {
    id: "tocumen",
    code: "PTY",
    image:
      "https://galeria.tocumenaero.com/gallery/api/Terminal%201%20y%202%20fachada%20d%C3%ADa%20y%20noche/321A5568_1.jpg",
    href: "/",
    isMain: true,
  },
  {
    id: "mppa",
    code: "BLB",
    image: "https://galeria.tocumenaero.com/gallery/regionales/MPPA.JPG",
    href: "/mppa",
  },
  {
    id: "david",
    code: "DAV",
    image: "https://galeria.tocumenaero.com/gallery/regionales/MPDA.JPG",
    href: "/mpda",
  },
  {
    id: "riohato",
    code: "RIH",
    image: "https://galeria.tocumenaero.com/gallery/regionales/MPSM2.jpg",
    href: "/mpsm",
  },
];
